export default __webpack_public_path__ + "static/media/51.b2fa03ac.png";